const TICKET_STATUSES = {
  OPEN: { tone: 'green', label: 'Open' },
  ASSIGNED: { tone: 'blue', label: 'Assigned' },
  CLOSED: { tone: 'green', label: 'Closed' },
  INVALID: { tone: 'red', label: 'Invalid' }
}

function ticketStatusTone(code) {
  const status = TICKET_STATUSES[String(code || '').toUpperCase()]
  return status ? status.tone : 'neutral'
}

function ticketStatusLabel(code, fallback) {
  const status = TICKET_STATUSES[String(code || '').toUpperCase()]
  return status ? status.label : (fallback || String(code || '') || 'Unknown')
}

module.exports = { ticketStatusTone, ticketStatusLabel }
